module.exports = ".address{\n    padding-right: 75px;\n}\n.error-box{\n    display: inline-block;\n    margin-bottom: 20px ;\n  }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/address-details2/address-details2.component.css
// module id = ./src/app/shared/components/address-details2/address-details2.component.css
// module chunks = main